import {defineLanguageOrder} from 'microsites/core/chatMicrosite/translations/utils/languageManifest';

export const CHATCOFFEE_LANGUAGE_ORDER = defineLanguageOrder([`ar-MA`, `ar-SA`, `de-DE`, `en-KE`, `en-NG`, `en-US`, `es-ES`, `fa-IR`, `fr-FR`, `hi-IN`, `it-IT`, `ja-JP`, `ko-KR`, `nl-NL`, `pt-PT`, `ru-RU`, `sv-SE`, `th-TH`, `yue-Hant-HK`, `zh-Hans-CN`] as const);
